/**
 * Route configuration for the application.
 * Centralizes all route definitions; consumed by App.js.
 */
import { CrisisResources, PrivacyPolicy } from '@/components/compliance';
import { LandingPage } from '@/pages/LandingPage';
import { BetaPage } from '@/pages/BetaPage';
import { SignUpPage } from '@/pages/SignUpPage';
import { LoginPage } from '@/pages/LoginPage';
import { TwoFactorPage } from '@/pages/TwoFactorPage';
import { EmailVerificationPage } from '@/pages/EmailVerificationPage';
import { ConsentPage } from '@/pages/ConsentPage';
import { OnboardingPage } from '@/pages/OnboardingPage';
import { AssessmentPage } from '@/pages/AssessmentPage';
import { PhaseAssignmentPage } from '@/pages/PhaseAssignmentPage';
import { AttachmentQuizPage } from '@/pages/AttachmentQuizPage';
import { CheckoutPage } from '@/pages/CheckoutPage';
import { SanctuaryPage } from '@/pages/SanctuaryPage';
import { ChatPage } from '@/pages/ChatPage';
import { ProgressPage } from '@/pages/ProgressPage';
import { JournalPage } from '@/pages/JournalPage';
import CirclePage from '@/pages/CirclePage';
import InnerWorldPage from '@/pages/InnerWorldPage';
import InnerWorldQuestPage from '@/pages/InnerWorldQuestPage';
import CouncilRosterPage from '@/pages/CouncilRosterPage';
import RestAtShorePage from '@/pages/RestAtShorePage';
import InnerHomePage from '@/pages/InnerHomePage';
import BookOfBecomingPage from '@/pages/BookOfBecomingPage';
import InnerWorldPreviewPage from '@/pages/InnerWorldPreviewPage';
import { PhaseReassessmentPage } from '@/pages/PhaseReassessmentPage';
import { SettingsPage } from '@/pages/SettingsPage';
import { AdminLoginPage } from '@/pages/AdminLoginPage';
import { AdminDashboardPage } from '@/pages/AdminDashboardPage';
import { PrivacyPolicyPage } from '@/pages/PrivacyPolicyPage';
import { TermsOfServicePage } from '@/pages/TermsOfServicePage';
import { SupportPolicyPage } from '@/pages/SupportPolicyPage';
import { MorningRitualPage } from '@/pages/MorningRitualPage';
import { BreathePage } from '@/pages/BreathePage';
import { ForgotPasswordPage } from '@/pages/ForgotPasswordPage';
import { ResetPasswordPage } from '@/pages/ResetPasswordPage';
import UnsubscribedPage from '@/pages/UnsubscribedPage';
import AuthCallback from '@/pages/AuthCallback';

// Public routes — no authentication required
export const PUBLIC_ROUTES = [
  { path: '/', Component: LandingPage },
  { path: '/beta', Component: BetaPage },
  { path: '/inner-world-preview', Component: InnerWorldPreviewPage },
  { path: '/signup', Component: SignUpPage },
  { path: '/login', Component: LoginPage },
  { path: '/forgot-password', Component: ForgotPasswordPage },
  { path: '/reset-password', Component: ResetPasswordPage },
  { path: '/unsubscribed', Component: UnsubscribedPage },
  { path: '/auth/callback', Component: AuthCallback },
  { path: '/verify-2fa', Component: TwoFactorPage },
  { path: '/verify-email', Component: EmailVerificationPage },
  { path: '/privacy', Component: PrivacyPolicyPage },
  { path: '/privacy-policy', Component: PrivacyPolicy },
  { path: '/crisis-resources', Component: CrisisResources },
  { path: '/terms', Component: TermsOfServicePage },
  { path: '/support', Component: SupportPolicyPage },
  { path: '/admin/login', Component: AdminLoginPage },
  { path: '/admin/dashboard', Component: AdminDashboardPage },
];

// Guarded routes — wrapped in ProtectedRoute with the given guard props
export const GUARDED_ROUTES = [
  { path: '/consent', Component: ConsentPage, guard: {} },
  { path: '/onboarding', Component: OnboardingPage, guard: { requireConsent: true } },
  { path: '/assessment', Component: AssessmentPage, guard: { requireConsent: true } },
  { path: '/phase-assignment', Component: PhaseAssignmentPage, guard: { requireConsent: true } },
  { path: '/attachment-quiz', Component: AttachmentQuizPage, guard: { requireConsent: true } },
  { path: '/checkout', Component: CheckoutPage, guard: { requireConsent: true, requireOnboarding: true } },
  { path: '/checkout-success', Component: CheckoutPage, guard: { requireConsent: true, requireOnboarding: true } },
  { path: '/sanctuary', Component: SanctuaryPage, guard: { requireSubscription: true } },
  { path: '/morning-ritual', Component: MorningRitualPage, guard: { requireSubscription: true } },
  { path: '/breathe', Component: BreathePage, guard: { requireSubscription: true } },
  { path: '/chat', Component: ChatPage, guard: { requireSubscription: true } },
  { path: '/progress', Component: ProgressPage, guard: { requireSubscription: true } },
  { path: '/journal', Component: JournalPage, guard: { requireSubscription: true } },
  { path: '/circle', Component: CirclePage, guard: { requireSubscription: true } },
  { path: '/inner-world', Component: InnerWorldPage, guard: { requireSubscription: true } },
  { path: '/inner-world/quest/:realm', Component: InnerWorldQuestPage, guard: { requireSubscription: true } },
  { path: '/inner-world/council', Component: CouncilRosterPage, guard: { requireSubscription: true } },
  { path: '/inner-world/rest', Component: RestAtShorePage, guard: { requireSubscription: true } },
  { path: '/inner-world/home', Component: InnerHomePage, guard: { requireSubscription: true } },
  { path: '/inner-world/book', Component: BookOfBecomingPage, guard: { requireSubscription: true } },
  { path: '/phase-reassessment', Component: PhaseReassessmentPage, guard: { requireSubscription: true } },
  { path: '/settings', Component: SettingsPage, guard: { requireSubscription: true } },
];
